import React from 'react';
import PersonRounded from '@material-ui/icons/PersonRounded';
import ButtonBase from '@material-ui/core/ButtonBase';
import {Link} from 'react-router-dom';
import { withResizer, withUser ,withTranslations} from '../../../../HoCs';
import Component from '../../../Component';
import styles from './styles';
import pages, { getRouteForPage } from '../../../../PageEnums';
import { forceLogout } from '../../../../services/Network';
import { merge } from '../../../../utils';

class AccountDetails extends Component {

    styles = styles;

    // onViewClick = () => window.location = pages.PROFILE.route;

    onSignoutClick = () => forceLogout();

    render = () => <div style={this.gs('container')}>
        <PersonRounded style={this.gs('person')} />
        <div style={this.gs('name')}>{this.getUserName()}</div>
        <div style={this.gs('number')}>{this.getPhone()}</div>
        <Link to={getRouteForPage(pages.PROFILE)}><ButtonBase style={this.gs('ripple')}><div style={this.gs('button')}>{this.guc('view_profile')}</div></ButtonBase></Link>
        <ButtonBase style={this.gs('signout_ripple')} onClick={this.onSignoutClick}><div style={merge(this.gs('button'), { border: 'none' })}>{this.guc('sign_out')}</div></ButtonBase>
    </div>;

}

export default withTranslations(withUser(withResizer(AccountDetails)));